import { api } from "./client";
import type { components } from "./types";

export type AuditEntry = components["schemas"]["AuditEntry"];

export interface ListAuditParams {
  project_id?: number;
  actor?: string;
  kind?: string;
  request_id?: string;
  date_from?: string;
  date_to?: string;
  cursor?: string;
  limit?: number;
}

export function listAudit(params: ListAuditParams = {}): Promise<AuditEntry[]> {
  const qs = new URLSearchParams();
  if (params.project_id !== undefined) qs.set("project_id", String(params.project_id));
  if (params.actor) qs.set("actor", params.actor);
  if (params.kind) qs.set("kind", params.kind);
  if (params.request_id) qs.set("request_id", params.request_id);
  if (params.date_from) qs.set("date_from", params.date_from);
  if (params.date_to) qs.set("date_to", params.date_to);
  if (params.cursor) qs.set("cursor", params.cursor);
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  const tail = qs.toString();
  return api.get<AuditEntry[]>(`/audit${tail ? `?${tail}` : ""}`);
}
